"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupInviteProvider = void 0;
const lodash_1 = __importDefault(require("lodash"));
const BaseDataProvider_1 = require("./BaseDataProvider");
class GroupInviteProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor() {
        super(...arguments);
        this.inviteQuery = (options) => {
            let query = this.refs.groupInvites();
            query = lodash_1.default.isNil(options.teacher) ? query : query.where('teachers', 'array-contains', options.teacher);
            query = lodash_1.default.isNil(options.reviewed) ? query : query.where('reviewed', '==', options.reviewed);
            query = lodash_1.default.isNil(options.userId) ? query : query.where('userId', '==', options.userId);
            return query;
        };
    }
    async addInvite(invite) {
        const ref = await this.refs.groupInvites().doc();
        await this.refs
            .groupInvites()
            .doc(ref.id)
            .set({ ...invite, id: ref.id });
    }
    invite(inviteId) {
        return this.docPromise(this.refs.groupInvite(inviteId));
    }
    activeInvitedStream(userId) {
        return this.collectionDataStream(this.inviteQuery({ userId }), false);
    }
    activeInviteStudentStream(userId) {
        return this.collectionDataStream(this.inviteQuery({ teacher: userId, reviewed: false }), false);
    }
}
exports.GroupInviteProvider = GroupInviteProvider;
//# sourceMappingURL=GroupInviteProvider.js.map